export default __webpack_public_path__ + "static/KMU_Digital-21bdf8b931467e05271b43d45f15cc17.png";